export default "__VITE_ASSET__DnClwnCI__"